import { Component, Input } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import {
  showCeReviewDetails,
  showClientConsultNoteTask,
  showClientPrescriberTask,
  showClientReferralTask,
} from '../../../core/lib/capture-nav-util';

import { CeReviewClientPrescriberTaskComponent } from '../ce-review-client-prescriber-task/ce-review-client-prescriber-task.component';
import { CeReviewClientReferralTaskComponent } from '../ce-review-client-referral-task/ce-review-client-referral-task.component';
import { CeReviewClientConsultNoteTaskComponent } from '../ce-review-client-consult-note-task/ce-review-client-consult-note-task.component';

@Component({
    selector: 'app-ce-review-details',
    templateUrl: './ce-review-details.component.html',
    imports: [CeReviewClientPrescriberTaskComponent,
              CeReviewClientReferralTaskComponent,
              CeReviewClientConsultNoteTaskComponent]
})
export class CeReviewDetailsComponent {
  @Input() capture: Capture;

  constructor() {}

  get showCeReviewDetails(): boolean {
    return showCeReviewDetails(this.capture);
  }

  get showClientPrescriberTask(): boolean {
    return showClientPrescriberTask(this.capture);
  }

  get showClientConsultNoteTask(): boolean {
    return showClientConsultNoteTask(this.capture);
  }

  get showClientReferralTask(): boolean {
    return showClientReferralTask(this.capture);
  }
}
